export default __webpack_public_path__ + "static/media/noun-warning-white.3a6048e5.svg";